__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "nace-platform-frontend";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult.catch(handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@ant-design/icons-vue", "6.0.1", function() { return function() { return __webpack_require__(81796); }; }, 1);
			register("@ant-design/icons-vue", "7.0.1", function() { return function() { return __webpack_require__(16051); }; }, 1);
			register("@qdata/ant-design-vue", "2.2.8-4", function() { return function() { return __webpack_require__(1340); }; }, 1);
			register("@vueuse/core", "10.11.0", function() { return function() { return __webpack_require__(70464); }; }, 1);
			register("@vueuse/core", "9.13.0", function() { return function() { return __webpack_require__(22915); }; }, 1);
			register("ant-design-vue", "4.2.3", function() { return function() { return __webpack_require__(61048); }; }, 1);
			register("axios", "0.23.0", function() { return function() { return __webpack_require__(9669); }; }, 1);
			register("bignumber.js", "9.0.1", function() { return function() { return __webpack_require__(44431); }; }, 1);
			register("echarts/charts", "5.2.1", function() { return function() { return __webpack_require__(15487); }; }, 1);
			register("echarts/components", "5.2.1", function() { return function() { return __webpack_require__(33317); }; }, 1);
			register("echarts/core", "5.2.1", function() { return function() { return __webpack_require__(34870); }; }, 1);
			register("echarts/renderers", "5.2.1", function() { return function() { return __webpack_require__(83465); }; }, 1);
			register("element-plus", "2.7.6", function() { return function() { return __webpack_require__(45934); }; }, 1);
			register("json-bigint", "1.0.0", function() { return function() { return __webpack_require__(4400); }; }, 1);
			register("lodash-es", "4.17.21", function() { return function() { return __webpack_require__(93455); }; }, 1);
			register("moment", "2.29.1", function() { return function() { return __webpack_require__(30381); }; }, 1);
			register("monaco-editor", "0.29.1", function() { return function() { return __webpack_require__(39283); }; }, 1);
			register("numeral", "2.0.6", function() { return function() { return __webpack_require__(92077); }; }, 1);
			register("store2", "2.12.0", function() { return function() { return __webpack_require__(11860); }; }, 1);
			register("vue-router", "4.0.11", function() { return function() { return __webpack_require__(42119); }; }, 1);
			register("vue", "3.2.11", function() { return function() { return __webpack_require__(58133); }; }, 1);
			register("xlsx", "0.17.3", function() { return function() { return __webpack_require__(7869); }; }, 1);
			initExternal(91);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};